
export function initKakaoTvApi(editor) {
  window.onAttachKakaoTv = function(linkUrl) {
    editor.execCommand('makeOpengraphWithKakaoTvService', linkUrl, ( appInfo.kakaoTvServiceKey ));
  };

  editor.addCommand('OpenKakaoTVUploader', () => {
    window.open(`${appInfo.manageUrl}/posts/attachVideo`, 'kakaotv', 'width=620px,height=700px')
  })
}

